import { render, staticRenderFns } from "./flowMgr.vue?vue&type=template&id=9724838e"
import script from "./flowMgr.vue?vue&type=script&lang=js"
export * from "./flowMgr.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports